import React, { useRef, useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import NavBar from "../NavBar/NavBar.tsx";
import Footer from "../Footer/Footer.tsx";

/* Colours: text #4e5356 | buttons #2596be | headings #4573a6 | background white
   Fonts  : Ubuntu Bold (headings) / Open Sans Regular (body) */

const MAP_URL = "https://maps.app.goo.gl/upfe796tcdbdB8p9A";

const contacts = [
  {
    title: "Address",
    href: MAP_URL,
    external: true,
    lines: ["18, TRIOS, Symphony IT Park, Nanded City, Pune - 411024"],
    icon: <><path d="M12 21s7-6.2 7-11.5A7 7 0 005 9.5C5 14.8 12 21 12 21z" /><circle cx="12" cy="9.5" r="2.5" /></>,
  },
  {
    title: "Call Us",
    href: "tel:9890521717",
    lines: ["+91 9890521717"],
    icon: <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 014.9 13.88 19.79 19.79 0 011.88 5.26 2 2 0 013.88 3h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L8.09 10.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 17.92z" />,
  },
  {
    title: "WhatsApp Us",
    href: "https://wa.me/+918080411453",
    external: true,
    lines: ["+91 80804 11453"],
    icon: <><path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z" /><path d="M9 10h6M9 13h4" /></>,
  },
  {
    title: "Email Us",
    lines: ["atul.w@theatum.com", "sanket.joshi@theatum.com"],
    links: ["mailto:atul.w@theatum.com", "mailto:sanket.joshi@theatum.com"],
    icon: <><rect x="2" y="4" width="20" height="16" rx="3" /><path d="M2 7l10 7 10-7" /></>,
  },
];

const services = [
  {
    key: "development",
    title: "Development",
    items: [
      "Web – ReactJS, Vue, Angular & Others",
      "Mobile – React Native, Ionic & Others",
      "Full Stack – NodeJS, Python, Ruby on Rails & Others",
    ],
    icon: <path d="M16 18l6-6-6-6M8 6l-6 6 6 6" />,
  },
  {
    key: "design & experience",
    title: "Design & Experience",
    items: [
      "UI/UX – Figma, Miro, Photoshop, Sketch & Others",
      "Digital Marketing",
      "Content Writing",
    ],
    icon: <><path d="M12 3a9 9 0 100 18c1.1 0 2-.9 2-2 0-.6-.3-1.1-.6-1.5-.3-.4-.4-.9-.4-1.5 0-1.1.9-2 2-2h2.3A3.7 3.7 0 0021 8.3C21 5.4 17 3 12 3z" /><circle cx="7.5" cy="11" r="1" /><circle cx="10" cy="7" r="1" /><circle cx="15" cy="7" r="1" /></>,
  },
  {
    key: "quality",
    title: "Quality",
    items: [
      "QA – Manual, Selenium Automation, Playwright, Cypress",
      "Testing",
    ],
    icon: <><path d="M12 3l8 3v6c0 5-3.5 8-8 9-4.5-1-8-4-8-9V6z" /><path d="M9 12l2 2 4-4" /></>,
  },
  {
    key: "support",
    title: "Support",
    items: ["Maintenance", "Resource Augmentation"],
    icon: <><path d="M4 14v-2a8 8 0 0116 0v2" /><rect x="2" y="14" width="4" height="6" rx="1.5" /><rect x="18" y="14" width="4" height="6" rx="1.5" /></>,
  },
];

const STYLES = `
@import url("https://fonts.googleapis.com/css2?family=Open+Sans:wght@400;600&family=Ubuntu:wght@700&display=swap");

.ct{--text:#4e5356;--head:#4573a6;--btn:#2596be;--tint:#eef6fa;--line:#d3e4ed;
  position:relative;overflow:hidden;background:#fff;font-family:"Open Sans",sans-serif;font-weight:400;color:var(--text)}
.ct-wrap{max-width:1240px;margin:0 auto;padding:0 24px}

.ct-chip{display:inline-block;margin-bottom:16px;padding:6px 18px;border-radius:50px;background:var(--tint);border:1px solid var(--line);
  color:var(--head);font-size:12px;letter-spacing:2px;text-transform:uppercase}
.ct h1,.ct h2{margin:0 0 14px;font-family:"Ubuntu",sans-serif;font-weight:700;font-size:42px;line-height:1.15;color:var(--head);cursor:default;transition:color .35s,letter-spacing .35s}
.ct h1:hover,.ct h2:hover{color:var(--btn);letter-spacing:.6px}
.ct-sub{display:flex;align-items:center;justify-content:center;gap:12px}
.ct-sub i{display:block;height:2px;width:40px;border-radius:2px;background:var(--btn)}.ct-sub i:last-child{background:var(--head)}
.ct-sub p{margin:0;font-size:15px;line-height:1.75}

/* scroll reveal */
.rv{opacity:0;transform:translateY(46px);transition:opacity .8s cubic-bezier(.2,.8,.2,1),transform .8s cubic-bezier(.2,.8,.2,1);transition-delay:var(--d,0s)}
.rv.in{opacity:1;transform:none}

/* ---------- HERO ---------- */
.ct-hero{text-align:center;padding:160px 0 60px;animation:ctDrop .9s cubic-bezier(.2,.8,.2,1) backwards}

/* ---------- CONTACT CARDS ---------- */
.ct-grid{display:grid;grid-template-columns:repeat(4,minmax(0,1fr));gap:22px}
.ct-card{--mx:50%;--my:50%;--rx:0deg;--ry:0deg;position:relative;overflow:hidden;height:100%;text-align:center;padding:36px 22px 30px;border-radius:24px;
  background:#fff;border:1px solid var(--line);box-shadow:0 18px 36px -26px rgba(69,115,166,.55);
  transform:perspective(900px) rotateX(var(--rx)) rotateY(var(--ry));transition:transform .18s ease-out,box-shadow .4s,border-color .4s}
.ct-card:hover{border-color:transparent;box-shadow:0 30px 50px -22px rgba(37,150,190,.7)}
.ct-glow{position:absolute;inset:0;pointer-events:none;opacity:0;transition:opacity .35s;
  background:radial-gradient(240px circle at var(--mx) var(--my),rgba(37,150,190,.16),rgba(69,115,166,.05) 45%,transparent 70%)}
.ct-card:hover .ct-glow{opacity:1}
.ct-top{position:absolute;top:0;left:0;width:100%;height:5px;transform:scaleX(0);transform-origin:left;background:linear-gradient(90deg,var(--head),var(--btn));transition:transform .55s cubic-bezier(.2,.8,.2,1)}
.ct-card:hover .ct-top{transform:scaleX(1)}
.ct-icon{position:relative;width:76px;height:76px;margin:0 auto 20px;border-radius:22px;background:var(--tint);display:flex;align-items:center;justify-content:center;
  transition:background .4s,box-shadow .4s,transform .5s cubic-bezier(.3,1.4,.5,1)}
.ct-icon svg{width:32px;height:32px;fill:none;stroke:var(--head);stroke-width:1.8;stroke-linecap:round;stroke-linejoin:round;transition:stroke .4s,transform .5s cubic-bezier(.3,1.4,.5,1)}
.ct-card:hover .ct-icon,.ct-svc:hover .ct-icon{background:linear-gradient(135deg,var(--head),var(--btn));transform:translateY(-6px);box-shadow:0 10px 22px -8px rgba(37,150,190,.6)}
.ct-card:hover .ct-icon svg,.ct-svc:hover .ct-icon svg{stroke:#fff;transform:scale(1.1)}
.ct-card h3{position:relative;display:inline-block;margin:0 0 12px;font-family:"Ubuntu",sans-serif;font-weight:700;font-size:20px;letter-spacing:.6px;color:var(--head)}
.ct-card h3::after{content:"";position:absolute;left:0;bottom:-5px;height:2px;width:0;background:var(--btn);transition:width .45s cubic-bezier(.2,.8,.2,1)}
.ct-card:hover h3::after{width:100%}
.ct-card p{position:relative;margin:0 0 6px;font-size:14.5px;line-height:1.75;color:var(--text)}
.ct-card a{position:relative;color:var(--text);text-decoration:none;word-break:break-word;transition:color .3s}
.ct-card a:hover{color:var(--btn)}

/* ---------- SERVICES ---------- */
.ct-sec{text-align:center;padding:100px 0 100px}
.ct-sec .ct-sub{margin-bottom:56px}
.ct-svcs{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:22px;text-align:left}
.ct-anchor{scroll-margin-top:110px}
.ct-svc{position:relative;overflow:hidden;height:100%;display:flex;gap:22px;align-items:flex-start;padding:34px 30px;border-radius:24px;
  background:#fff;border:1px solid var(--line);box-shadow:0 18px 36px -26px rgba(69,115,166,.55);
  transition:transform .4s cubic-bezier(.3,1.4,.5,1),box-shadow .4s,border-color .4s}
.ct-svc:hover{transform:translateY(-8px);border-color:rgba(37,150,190,.5);box-shadow:0 30px 50px -22px rgba(37,150,190,.6)}
.ct-svc::before{content:"";position:absolute;top:0;left:0;width:100%;height:5px;transform:scaleX(0);transform-origin:left;background:linear-gradient(90deg,var(--head),var(--btn));transition:transform .55s cubic-bezier(.2,.8,.2,1)}
.ct-svc:hover::before{transform:scaleX(1)}
.ct-svc .ct-icon{flex:none;margin:0}
.ct-svc h3{margin:0 0 12px;font-family:"Ubuntu",sans-serif;font-weight:700;font-size:20px;letter-spacing:.6px;color:var(--head)}
.ct-svc ul{list-style:none;margin:0;padding:0}
.ct-svc li{position:relative;padding:5px 0 5px 22px;font-size:14.5px;line-height:1.6;color:var(--text)}
.ct-svc li::before{content:"";position:absolute;left:0;top:13px;width:8px;height:8px;border-radius:50%;background:linear-gradient(135deg,var(--head),var(--btn))}
.ct-hl .ct-svc{border-color:rgba(37,150,190,.6);box-shadow:0 0 0 4px rgba(37,150,190,.12),0 30px 50px -22px rgba(37,150,190,.6)}

@keyframes ctDrop{from{opacity:0;transform:translateY(-30px)}}

@media(max-width:1100px){.ct-grid{grid-template-columns:repeat(2,minmax(0,1fr))}}
@media(max-width:900px){.ct-svcs{grid-template-columns:1fr}}
@media(max-width:600px){
  .ct-hero{padding:130px 0 40px}
  .ct h1,.ct h2{font-size:30px}
  .ct-grid{grid-template-columns:1fr}
  .ct-sec{padding:70px 0}
  .ct-svc{flex-direction:column;padding:28px 22px}
  .ct-sub i{display:none}
}
@media(prefers-reduced-motion:reduce){
  .ct *,.ct *::before,.ct *::after{animation:none!important;transition:none!important}
  .rv{opacity:1;transform:none}
}
`;

/* fades a block in once it scrolls into view */
const Reveal = ({ children, delay = 0 }) => {
  const ref = useRef(null);
  const [show, setShow] = useState(false);
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setShow(true);
          observer.disconnect();
        }
      },
      { threshold: 0.12 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);
  return (
    <div ref={ref} className={"rv" + (show ? " in" : "")} style={{ "--d": delay + "s", height: "100%" }}>
      {children}
    </div>
  );
};

const ContactCard = ({ item }) => {
  const ref = useRef(null);

  const handleMove = (e) => {
    const el = ref.current;
    if (!el) return;
    const r = el.getBoundingClientRect();
    const x = e.clientX - r.left;
    const y = e.clientY - r.top;
    el.style.setProperty("--mx", x + "px");
    el.style.setProperty("--my", y + "px");
    el.style.setProperty("--ry", ((x / r.width - 0.5) * 8).toFixed(2) + "deg");
    el.style.setProperty("--rx", ((0.5 - y / r.height) * 8).toFixed(2) + "deg");
  };
  const handleLeave = () => {
    if (!ref.current) return;
    ref.current.style.setProperty("--rx", "0deg");
    ref.current.style.setProperty("--ry", "0deg");
  };

  const linkProps = item.external ? { target: "_blank", rel: "noopener noreferrer" } : {};

  return (
    <div className="ct-card" ref={ref} onMouseMove={handleMove} onMouseLeave={handleLeave}>
      <div className="ct-top" />
      <div className="ct-glow" />
      <div className="ct-icon"><svg viewBox="0 0 24 24">{item.icon}</svg></div>
      <h3>{item.title}</h3>
      {item.lines.map((line, i) => (
        <p key={line}>
          <a href={item.links ? item.links[i] : item.href} {...linkProps}>{line}</a>
        </p>
      ))}
    </div>
  );
};

const ContactPage = () => {
  const location = useLocation();
  const refs = {
    development: useRef(null),
    "design & experience": useRef(null),
    quality: useRef(null),
    support: useRef(null),
  };
  const [active, setActive] = useState("");

  // scroll to the requested section (e.g. history.push("/contact", { section: "Quality" }))
  useEffect(() => {
    const section = location.state && location.state.section
      ? String(location.state.section).toLowerCase()
      : "";
    const target = refs[section];
    if (target && target.current) {
      setActive(section);
      setTimeout(() => target.current.scrollIntoView({ behavior: "smooth", block: "start" }), 150);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.state]);

  return (
    <div>
      <NavBar />
      <style>{STYLES}</style>

      <div className="ct">
        <div className="ct-wrap">
          {/* HERO */}
          <div className="ct-hero">
            <div className="ct-chip">Contact Us</div>
            <h1>Get In Touch</h1>
            <div className="ct-sub">
              <i />
              <p>We would love to hear about your project.</p>
              <i />
            </div>
          </div>

          {/* CONTACT CARDS */}
          <div className="ct-grid">
            {contacts.map((c, i) => (
              <Reveal key={c.title} delay={i * 0.1}>
                <ContactCard item={c} />
              </Reveal>
            ))}
          </div>

          {/* SERVICES */}
          <div className="ct-sec">
            <div className="ct-chip">What We Offer</div>
            <h2>Our Expertise</h2>
            <div className="ct-sub">
              <i />
              <p>Development, design, quality and support under one roof.</p>
              <i />
            </div>

            <div className="ct-svcs">
              {services.map((s, i) => (
                <div
                  key={s.key}
                  ref={refs[s.key]}
                  className={"ct-anchor" + (active === s.key ? " ct-hl" : "")}
                >
                  <Reveal delay={(i % 2) * 0.1}>
                    <div className="ct-svc">
                      <div className="ct-icon"><svg viewBox="0 0 24 24">{s.icon}</svg></div>
                      <div>
                        <h3>{s.title}</h3>
                        <ul>
                          {s.items.map((item) => (
                            <li key={item}>{item}</li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  </Reveal>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* footer Section */}
      <Footer />
    </div>
  );
};

export default ContactPage;